/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Controls_Aria_LabelInputs */

const en_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeline controls`)
};

const fr_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de la chronologie`)
};

const de_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitleistensteuerung`)
};

const it_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlli della cronologia`)
};

const ru_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Элементы управления временной шкалой`)
};

const es_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles de la línea de tiempo`)
};

const zh_cn2_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间线控件`)
};

const ja_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムラインコントロール`)
};

const hi_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समयरेखा नियंत्रण`)
};

const pt_pt2_timeline_controls_aria_label = /** @type {(inputs: Timeline_Controls_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controles da linha do tempo`)
};

/**
* | output |
* | --- |
* | "Timeline controls" |
*
* @param {Timeline_Controls_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_controls_aria_label = /** @type {((inputs?: Timeline_Controls_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Controls_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_controls_aria_label(inputs)
	if (locale === "de") return de_timeline_controls_aria_label(inputs)
	if (locale === "it") return it_timeline_controls_aria_label(inputs)
	if (locale === "ru") return ru_timeline_controls_aria_label(inputs)
	if (locale === "es") return es_timeline_controls_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_controls_aria_label(inputs)
	if (locale === "ja") return ja_timeline_controls_aria_label(inputs)
	if (locale === "hi") return hi_timeline_controls_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_controls_aria_label(inputs)
	return en_timeline_controls_aria_label(inputs)
});